import { Switch as HSwitch } from '@headlessui/react'
import cx from 'classnames'
import type { HTMLAttributes } from 'react'

import { focusRingStyles } from '../../libs/focusRingStyles'
import { paperStyles } from '../../libs/paperStyles'

export type RawSwitchProps = Omit<HTMLAttributes<HTMLElement>, 'onChange'> & {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

export function RawSwitch({
  checked,
  onChange,
  disabled = false,
  ...restProps
}: RawSwitchProps) {
  const toggleState = checked ? 'on' : 'off'
  const disabledStyles = cx('cursor-not-allowed bg-slate-200 dark:bg-slate-700')
  const enabledStyles = focusRingStyles({ hasError: false })
  return (
    <HSwitch
      {...restProps}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      data-autofocus
      className={cx(
        'relative inline-flex h-4 w-7 shrink-0 items-center rounded-full transition-colors duration-200 ease-in-out',
        {
          on_enabled: cx(enabledStyles, 'bg-primary-500'),
          off_enabled: cx(enabledStyles, 'bg-slate-400 dark:bg-slate-600'),
          on_disabled: disabledStyles,
          off_disabled: disabledStyles,
        }[`${toggleState}_${disabled ? 'disabled' : 'enabled'}` as const],
      )}
    >
      <span
        className={cx(
          paperStyles(),
          'mx-0.5 inline-block size-3 rounded-full transition duration-200 ease-in-out',
          {
            on: 'translate-x-3',
            off: 'translate-x-0',
          }[toggleState],
        )}
      />
    </HSwitch>
  )
}
